import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'jsonParse',
  standalone: false,
})
export class JsonParsePipe implements PipeTransform {
  transform(value: string): unknown {
    // An empty string is an absent value, not malformed JSON: the view declares no customParameter,
    // or the model carrying the id is not loaded yet. Both are expected, neither is an error.
    if (!value) return null;

    try {
      return JSON.parse(value);
    } catch (e) {
      console.error('jsonParse pipe error:', e, '| value:', value);
      return null;
    }
  }
}
